import { useState } from "react";
import { getPlatformInfo, getEmbedUrl, getThumbnailUrl } from "../services/highlightsService";
import { VscPlay, VscLinkExternal, VscClose } from "react-icons/vsc";
import "./HighlightsDisplay.css";

function HighlightsDisplay({ highlights }) {
    const [activeVideo, setActiveVideo] = useState(null);

    if (!highlights || highlights.length === 0) {
        return null;
    }

    const openVideo = (highlight) => {
        const embedUrl = getEmbedUrl(highlight.url, highlight.platform);
        if (embedUrl) {
            setActiveVideo({ ...highlight, embedUrl });
        } else {
            // Open in new tab for non-embeddable platforms
            window.open(highlight.url, "_blank", "noopener,noreferrer");
        }
    };

    const closeVideo = () => {
        setActiveVideo(null);
    };

    return (
        <div className="highlights-display">
            <h2>Highlights</h2>

            <div className="highlights-grid">
                {highlights.map((highlight) => {
                    const platformInfo = getPlatformInfo(highlight.platform);
                    const thumbnail = getThumbnailUrl(highlight.url, highlight.platform);

                    return (
                        <div 
                            key={highlight.id} 
                            className="highlight-card"
                            onClick={() => openVideo(highlight)}
                        >
                            <div 
                                className="highlight-thumbnail"
                                style={thumbnail ? { backgroundImage: `url(${thumbnail})` } : {}}
                            >
                                <div 
                                    className="highlight-platform-icon"
                                    style={{ backgroundColor: platformInfo.color }}
                                >
                                    {platformInfo.icon}
                                </div>
                                <div className="highlight-play-overlay">
                                    <VscPlay />
                                </div>
                            </div>
                            <div className="highlight-card-info">
                                <span className="highlight-card-title">
                                    {highlight.title || platformInfo.label + " Video"}
                                </span>
                                <span className="highlight-card-platform">
                                    {platformInfo.label}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* Video Modal */}
            {activeVideo && (
                <div className="highlight-modal-overlay" onClick={closeVideo}>
                    <div className="highlight-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="highlight-modal-header">
                            <h3>{activeVideo.title || "Video"}</h3>
                            <button className="highlight-modal-close" onClick={closeVideo}>
                                <VscClose />
                            </button>
                        </div>
                        <div className="highlight-modal-content">
                            <iframe
                                src={activeVideo.embedUrl}
                                title={activeVideo.title || "Video"}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        </div>
                        <div className="highlight-modal-footer">
                            <a 
                                href={activeVideo.url} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="highlight-external-link"
                            >
                                <VscLinkExternal /> Open in {getPlatformInfo(activeVideo.platform).label}
                            </a>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default HighlightsDisplay;
